module.exports = __webpack_public_path__ + "media/images/LED-icon-grey-e04e3e9f2e239b872d4467298a3d99d2.svg";